import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_OrderOfServices = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_OrderOfServices' className='file-pdf-document'>
            <div className='file-template'>

                <h3>ORDER FOR SERVICES</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Individual Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Start Date.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtIndividualName" name="txtIndividualName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtStartDate" name="txtStartDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Treatment Services
                </h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Enter a X next to all services which are being ordered. Treatment Orders are in effect for 365 days.</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb1" name="cb1" className='add-only' value="Behavioral" />
                            Behavioral Health Assessment
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb2" name="cb2" className='add-only' value="Behavioral1" />
                            Service Plan Development
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb3" name="cb3" className='add-only' value="Behavioral2" />
                            Diagnostic Assessment
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb4" name="cb4" className='add-only' value="Behavioral3" />
                            Psychiatric Treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb5" name="cb5" className='add-only' value="Behavioral4" />
                            Nursing Assessment & Health Services
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb6" name="cb6" className='add-only' value="Behavioral5" />
                            Medication Administration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb7" name="cb7" className='add-only' value="Behavioral6" />
                            Individual Counseling
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb8" name="cb8" className='add-only' value="Behavioral7" />
                            Family Outpatient Services: Counseling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb9" name="cb9" className='add-only' value="Behavioral8" />
                            Family Outpatient Services: Training
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb10" name="cb10" className='add-only' value="Behavioral9" />
                            Group Outpatient Services: Counseling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb11" name="cb11" className='add-only' value="Behavioral10" />
                            Group Outpatient Services: Counseling
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb12" name="cb12" className='add-only' value="Behavioral11" />
                            Crisis Intervention
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb13" name="cb13" className='add-only' value="Behavioral12" />
                            Psychological Testing
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb14" name="cb14" className='add-only' value="Behavioral13" />
                            Psychological Rehabilitation Individual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb15" name="cb15" className='add-only' value="Behavioral14" />
                            Case Management
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb16" name="cb16" className='add-only' value="Behavioral15" />
                            Addictive Disease Support Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb17" name="cb17" className='add-only' value="Behavioral16" />
                            Community Support Individual
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cb18" name="cb18" className='add-only' value="Behavioral17" />
                            Intensive Family Intervention
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cb23" name="cb23" className='add-only' value="Behavioral22" />
                            Lipid Panel
                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb19" name="cb19" className='add-only' value="Behavioral18" />
                            Initial Standard Labs:<br />
                            <span className='small'>CMP, CBC w/diff, Al c, TSH, Urinalysis routine w/micros, Urine Drug Screen w/reflex, Urine Validity test, TB skin test, Hepatitis Screen-Acute Hepatitis Panel, HIV
                                AG/AB Combo 1/2, RPR-Rapid Plasma Reagin, Urine STI PCR Panel (STI workup), Urine Pregnancy Test
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb20" name="cb20" className='add-only' value="Behavioral19" />
                            Follow-Up Labs:<br />
                            <span className='small'>Random UDS w/reflex, Urine Validity test</span>
                        </td></tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb21" name="cb21" className='add-only' value="Behavioral20" />
                            Labs for Follow-up Psychotropic Medication:<br />
                            <span className='small'>CMP, CBC w/diff, Al C, TSH, Urinalysis routine w/micros, Urine Drug Screen w/reflex, Urine Validity test</span>
                        </td></tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cb22" name="cb22" className='add-only' value="Behavioral21" />
                            Labs for Follow-Up Mood Stabilizer Medications:<br />
                            <span className='small'>CBC w/diff, ValporicAcid(Depakote Levels), Carbamazepine (Tegretol) levels, Lithium Levels
                            </span>
                        </td></tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-450'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-450'> hysician Printed Name & Credentials </td>
                        <td className='small w-300'> Date of Signature</td>
                    </tr>
                </table>








            </div>
        </form>

    )
}